import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAccommodationContact($companyId: ID!, $attributes: AccommodationContactAttributes!) {
    createAccommodationContact(companyId: $companyId, attributes: $attributes) {
      accommodationContact {
        id
        ...CreatedAccommodationContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAccommodationContact on AccommodationContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
  }
`
